const { createSpecies, duplicateSpecies } = require('./data/Species');
const Species = require('./data/Species');
const Leader = require('./data/Leader');
const Trait = require('./data/Trait');
const Quirk = require('./data/Quirk');
const Player = require('./data/Player');
const InventoryItem = require('./data/InventoryItem');
const Image = require('./data/Image');
const Card = require('./data/Card');
const Event = require('./data/Event');
const Collections = require('./constants/collections');
const Misc = require('./constants/misc');
const InventoryItemTypes = require('./constants/inventoryItemTypes');
const InventoryItemSubTypes = require('./constants/inventoryItemSubTypes');
const InventoryItemTypeIds = require('./constants/inventoryItemTypeIds');
const EventTypes = require('./constants/events');

module.exports = {
  ...Species,
  ...Leader,
  ...Trait,
  ...Quirk,
  ...Player,
  ...InventoryItem,
  ...Image,
  ...Card,
  ...Event,
  Collections, Misc, InventoryItemTypes, InventoryItemSubTypes, InventoryItemTypeIds, EventTypes
};
